import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import DataTable from "@/components/DataTable";
import Modal, { Field, TextInput, Select, PrimaryButton, SecondaryButton } from "@/components/FormKit";
import { toast } from "sonner";
import { fmtDate } from "@/lib/format";

const initial = { email: "", password: "", name: "", role: "company_user" };

export default function Users() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(initial);

  const load = async () => setItems((await api.get("/company/users")).data);
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/company/users", form);
      toast.success("User created");
      setOpen(false);
      setForm(initial);
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div className="space-y-8" data-testid="company-users-page">
      <PageHeader
        eyebrow="Team"
        title="Company users"
        description="Admins and users with access to your workspace."
        actions={<PrimaryButton onClick={() => setOpen(true)} testId="new-user-button">+ Invite User</PrimaryButton>}
      />

      <DataTable
        testId="users-table"
        columns={[
          { key: "name", label: "Name", render: (r) => <div className="font-bold">{r.name}</div> },
          { key: "email", label: "Email" },
          { key: "role", label: "Role", render: (r) => <span className="font-mono text-xs uppercase tracking-wider">{r.role}</span> },
          { key: "created_at", label: "Joined", render: (r) => fmtDate(r.created_at) },
        ]}
        rows={items}
        empty="No users yet."
      />

      <Modal open={open} onClose={() => setOpen(false)} title="Invite user">
        <form onSubmit={submit}>
          <Field label="Name"><TextInput testId="form-user-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></Field>
          <Field label="Email"><TextInput testId="form-user-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></Field>
          <Field label="Temporary password"><TextInput testId="form-user-password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} /></Field>
          <Field label="Role">
            <Select testId="form-user-role" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })}>
              <option value="company_user">Company User</option>
              <option value="company_admin">Company Admin</option>
            </Select>
          </Field>
          <div className="flex justify-end gap-2 pt-2">
            <SecondaryButton type="button" onClick={() => setOpen(false)}>Cancel</SecondaryButton>
            <PrimaryButton type="submit" testId="submit-user">Create</PrimaryButton>
          </div>
        </form>
      </Modal>
    </div>
  );
}
